import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import { Toast } from 'primereact/toast'
import { useNavigate, useParams } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import API_ENDPOINTS from '../../helperFunction/Constant'
import ApiHelper from '../../helperFunction/ApiHelper'
import * as yup from "yup";

const Profile = () => {

  const toast = useRef(null)
  const [profileData, setProfileData] = useState([])
  
  const schema = yup.object({
    name: yup.string().notRequired()
  });

  const { register, handleSubmit, reset, watch, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });
  useEffect(() => {
    getProfileData()
  }, [])
  
  const getProfileData = async () => {
    await ApiHelper.get(`${API_ENDPOINTS.ADMIN_PROFILE}`).then((res) => {
    console.log('res: ', res);
    if (res.status === 200) {
        setProfileData(res.data.data)
        reset({name: res.data.data.name})
        }
    }).catch((error) => {
        console.log("Error: ", error);
    })
  }
  const update = (data) => {
    ApiHelper.put(`${API_ENDPOINTS.ADMIN_PROFILE}/update`, data).then((res) => {
      if (res.status === 200) {
        toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
        localStorage.setItem('userName', watch('name'))
        getProfileData()
      }
    }).catch((error) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
    })
  };

  return (
    <>
      <Toast ref={toast} />
      <Layout>
        <div class="content-wrapper">
          <div class="container-xxl flex-grow-1 container-p-y">
            <div class="d-flex justify-content-between align-items-center py-3">
              <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page"> Profile </p> </span></h4>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="card mb-4">
                  <div class="card-body">
                    <form onSubmit={handleSubmit(update)}>
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label className="fw-semibold text-muted">Full Name</label>
                          <input className="form-control" type='text' placeholder='Name' {...register('name')} />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="fw-semibold text-muted">Email</label>
                          <input className="form-control" type='text' placeholder='Email' value={profileData.email} readOnly />
                        </div>
                      </div>
                      <div className="text-end mt-3">
                        <button type="submit" className="btn btn-primary"> Update </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout> 
    </>
  )
}

export default Profile
